var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100 vertical-flex-container tab-container" },
    [
      _c(
        "div",
        {
          staticClass:
            "row justify-content-center align-items-center py-3 position-sticky vertical-flex-auto",
          attrs: { id: "all-activity-header" },
        },
        [
          _c("div", { staticClass: "col-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "pretty p-default p-jelly p-primary p-round p-centered m-0",
              },
              [
                _c("input", {
                  attrs: {
                    id: "view-activities",
                    name: "view-type",
                    type: "radio",
                  },
                  domProps: {
                    checked:
                      _vm.currentPage === _vm.ActivitiesTabs.UpcomingActivities,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setCurrentPage(
                        _vm.ActivitiesTabs.UpcomingActivities
                      )
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "state p-success p-primary-alt" }, [
                  _c(
                    "label",
                    {
                      staticClass: "clickable",
                      attrs: { for: "view-activities" },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm._f("capitalize")(
                            _vm.$tc("global.words.activity", 2)
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "pretty p-default p-jelly p-primary p-round p-centered m-0",
              },
              [
                _c("input", {
                  attrs: {
                    id: "view-client-activity",
                    name: "view-type",
                    type: "radio",
                  },
                  domProps: {
                    checked: _vm.currentPage === "client-activities",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setCurrentPage("client-activities")
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "state p-success p-primary-alt" }, [
                  _c(
                    "label",
                    {
                      staticClass: "clickable",
                      attrs: { for: "view-client-activity" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("notifications.messages.clientActivity"))
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "m-0" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "row no-gutters my-0 py-0 vertical-flex-fit activity-wrapper",
        },
        [
          _c(_vm.currentPage + "-container", {
            tag: "component",
            attrs: { loading: _vm.loading },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "row justify-content-around align-items-center py-1 position-sticky vertical-flex-auto",
          attrs: { id: "all-activity-footer" },
        },
        [
          _c("activity-filter", {
            attrs: { "current-page": _vm.currentPage, filters: _vm.filters },
            on: { change: _vm.handleActivityFilter },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }